<template>
  <div v-if="serverdate && !loading">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
          <div class="text-container">
        <div class="title-area">
          <h1 class="page-title">
              <span
                :class="`${anon ? 'g-anon' : '' }`"
              >
                {{ survey_name }}:
              </span>
              {{ screentexts[50]?screentexts[50].element_text:'Set Survey Dates' }}
              <!-- <PopupBubble
                v-if="screentexts[50] && screentexts[50].element_bubbletext !== '' && screentexts[50].element_bubbletext !== null"
                screenelement_id="50"
                :screen_id="screen_id"
                :bubbletext="screentexts[50]?screentexts[50].element_bubbletext:''"
              /> -->
          </h1>
        </div>
        <h4 class="text-md">{{ screentexts[51]?screentexts[51].element_text:'When would you like to launch the survey?' }}</h4>
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="send-date-now"
              name="send_date"
              value="A"
              v-model="selected"
            />
            <label class="form-check-label" for="send-date-now">
              {{ screentexts[52]?screentexts[52].element_text:'Right Now' }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="send-date-later"
              name="send_date"
              value="B"
              v-model="selected"
            />
            <label class="form-check-label" for="send-date-later">
              {{ screentexts[53]?screentexts[53].element_text:'At a particular date and time (CET)' }},
              <br><br>Current date and time CET: {{ serverdate && serverdate.substring(0,10) }} {{ serverdate && serverdate.substring(11,16) }}
            </label>
          </div>
        </div>
        <div
          v-show="selected === 'B'"
        >
          <form @submit.stop.prevent>
            <div class="form-group">
              <label>
                {{ screentexts[58]?screentexts[58].element_text:'Date' }}
              </label>
              <BaseDatePicker
                id="start_date"
                v-model="start_date"
                :min-datetime="new Date().toLocaleDateString('sv-SE')"
              />
            </div>
            <div class="form-group">
              <label>
                {{ screentexts[59]?screentexts[59].element_text:'Time' }}
              </label>
              <Datetime
                id="start_time"
                v-model="start_time"
                type="time"
                input-class="form-control"
                :format="'HH:mm'"
                :placeholder="screentexts[62]?screentexts[62].element_text:'Select sending time'"
                @input="checkstartdate"
              />
              <span class="text-danger" v-show="showtimeadjust">The selected date and time has already past, the invitations will be sent out within 5 minutes after finishing the set-up.</span>
            </div>
          </form>
        </div>
        <h4 class="text-md">{{ screentexts[54]?screentexts[54].element_text:'When is the last day your participants can respond to this survey?' }}</h4>
        <div class="form-group">
          <small class="form-text">
            {{ screentexts[55]?screentexts[55].element_text:'The report will only take a few seconds for our system to calculate, but we recommend that you pull your report a few days in advance so you can prepare for your presentation' }}
          </small>
          <form @submit.stop.prevent>
            <div class="form-group">
              <label>
                {{ screentexts[58]?screentexts[58].element_text:'Date' }}
              </label>
                <BaseDatePicker
                  id="end_date"
                  v-model="end_date"
                  :min-datetime="serverdate"
                />
            </div>
          </form>
        </div>
        <div v-if="canremind">
          <h4 class="text-md">
            <span
              v-html="screentexts[56]?screentexts[56].element_text:'Would you like to schedule a reminder to help keep an eye on how your data collection is going and perhaps remind your participants to take part?'"
            />
          </h4>
            <div class="">
            <div class="form-group">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="reminder"
                  v-model="reminder"
                  :true-value="'1'"
                  :false-value="'0'"
                />
                <label class="form-check-label" for="reminder">
                  {{ screentexts[63]?screentexts[63].element_text:'Yes' }}
                </label>
              </div>
            </div>
            <div v-show="showReminder">
              <div class="form-group">
                <label>
                  {{ screentexts[65]?screentexts[65].element_text:'Send reminder to this e-mail' }}
                </label>
                <small class="form-text">
                  {{ screentexts[65]?screentexts[65].element_bubbletext:'Leave this field blank if you do not want a reminder e-mail' }}
                </small>
                <input
                  type="text"
                  :class="['form-control', anon ? 'g-anon' : '', reminder_email_valid === 'invalid' ? 'is-invalid' : '']"
                  v-model="reminder_email"
                />
                <div class="invalid-feedback" v-if="reminder_email_valid === 'invalid'">
                  {{ screentexts[66]?screentexts[66].element_text:'Invalid e-mail address' }}
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{ screentexts[67]?screentexts[67].element_text:'On this date:' }}
                </label>
                <form
                  @submit.stop.prevent
                >
                  <BaseDatePicker
                    id="reminder_date"
                    v-model="reminder_date"
                    :min-datetime="reminder_date_min.toISOString()"
                  />
                </form>
              </div>
            </div>
          </div>
        </div>

        <h4 class="text-md">{{ screentexts[57]?screentexts[57].element_text:'Would you like to send out an automatic reminder email to all of your participants to answer the questionnaire 3 days before the last day?' }}</h4>
        <div class="form-group">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="remindparticipants-yes"
              name="remindparticipants_action"
              value="1"
              v-model="remindparticipants"
            />
            <label class="form-check-label" for="remindparticipants-yes">
              {{ screentexts[63]?screentexts[63].element_text:'Yes' }}
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              id="remindparticipants-no"
              name="remindparticipants_action"
              value="0"
              v-model="remindparticipants"
            />
            <label class="form-check-label" for="remindparticipants-no">
              {{ screentexts[64]?screentexts[64].element_text:'No' }}
            </label>
          </div>
        </div>
        <div class="buttons-navigation">
          <router-link
            v-if="has_online === 1"
            to="/create/group/survey/emailsettings"
            class="btn btn-secondary float-left"
          >
            &lt; {{ screentexts[68]?screentexts[68].element_text:'Back' }}
          </router-link>
          <router-link
            v-if="has_online === 0"
            to="/create/group/survey/details"
            class="btn btn-secondary float-left"
          >
            &lt; {{ screentexts[68]?screentexts[68].element_text:'Back' }}
          </router-link>
          <router-link
            to="/create/group/survey/launch"
            class="btn btn-primary float-right"
          >
            {{ screentexts[69]?screentexts[69].element_text:'Next' }} &gt;
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { config } from '../../config'
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import Datetime from './custom/Datetime.vue'
import BaseDatePicker from './base/BaseDatePicker.vue'

export default {
  name: 'CreateGroupSurveyDates',
  components: {
    Navbar,
    Breadcrumb,
    Datetime,
    BaseDatePicker
    // PopupBubble,
  },
  data () {
    return {
      serverdate: null,
      timeZone: config.timeZone,
      showtimeadjust: false,
      group_name: this.$store.state.currentgroup.group_name,
      survey_name: this.$store.state.currentsurvey.survey_name,
      reminder: 0,
      reminder_mobile: '',
      remindparticipants: 0,
      selected: 'A',
      start_date: this.default_start_date(),
      start_time: null,
      end_date: null,
      reminder_date: this.default_reminder_date(),
      reminder_time: new Date().toLocaleString('sv-SE', { timeZone: config.timeZone }),
      reminder_email: this.$store.state.user.email,
      reminder_email_valid: null,
      has_online: 0,
      has_paper: 0,
      screen_id: 8,
      screentexts: [],
      loading: true
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    survey_id: {
      get () {
        return this.$store.state.currentsurvey.id
      },
      set () {
        return true
      }
    },
    start_date_min: {
      get () {
        return new Date(this.serverdate).toISOString()
      },
      set () {
        return true
      }
    },
    start_time_min: {
      get () {
        return '00:00'
      },
      set () {
        return true
      }
    },
    reminder_date_min: {
      get () {
        const newvalue = new Date(this.start_date)
        newvalue.setDate(newvalue.getDate() + 1)
        return newvalue
      },
      set () {
        return true
      }
    },
    canremind: {
      get () {
        const nowvalue = new Date(this.serverdate)
        const endvalue = new Date(this.end_date)
        return endvalue > nowvalue
      },
      set () {
        return true
      }
    },
    showReminder () {
      return this.reminder === '1' || this.reminder === 1
    }
  },
  watch: {
    selected: function () {
      if (!this.serverdate) return
      
      if (this.selected === 'A') {
        // Launch Now - use server's CET date/time as-is
        this.start_date = this.serverdate.substring(0, 10)
        this.start_time = this.serverdate.substring(11, 16)
      } else {
        // Launch Later - default to tomorrow at server time
        const d = new Date(this.serverdate)
        d.setDate(d.getDate() + 1)
        this.start_date = d.toLocaleDateString('sv-SE', { timeZone: this.timeZone })
        this.start_time = d.toLocaleTimeString('sv-SE', { timeZone: this.timeZone, hour: '2-digit', minute: '2-digit' })
      }
    },
    serverdate: function () {
      if (this.start_time === null) {
        this.start_time = new Date(this.serverdate).toISOString()
      }
    },
    start_date: function (newval, oldval) {
      console.log('Start date changed from ' + oldval + ' to ' + newval)
    }
  },
  async created () {
    this.loading = true
    await this.screentexts_get()
    await this.cetdate_get()
    this.end_date = this.default_end_date()
    await this.survey_get()
    
    // Initialize start_date and start_time based on current selection
    if (this.selected === 'A' && this.serverdate) {
      // Launch Now - use server's CET date/time as-is
      this.start_date = this.serverdate.substring(0, 10)
      this.start_time = this.serverdate.substring(11, 16)
    }
    
    this.loading = false
  },
  async beforeRouteLeave (to, from, next) {
    // ----------------------------
    // We are going forward - save
    // ----------------------------
    if (to.name === 'creategroupsurveylaunch') {
      if (this.validateform()) {
        await this.groupsurvey_save()
        next()
      }
    } else {
      next()
    }
  },
  methods: {
    // cetdate_toISOString(date) {
    //   console.log('cetdate_toISOString', new Date(date.toLocaleString('sv-SE', { timeZone: this.timeZone })).toISOString())
    //   const cetdateIso = new Date(date.toLocaleString('sv-SE', { timeZone: this.timeZone })).toISOString()
    //   return cetdateIso
    // },
    cetdate_get: async function () {
      await this.$store.dispatch('serverdate_fetch')
        .then((resp) => {
          const date = resp.data
          this.serverdate = date
          return this.serverdate
        })
    },
    checkstartdate () {
      if (this.loading === true) { return true }
      this.showtimeadjust = false
      const startValue = new Date(
        `${this.start_date.substring(0, 10)}T${this.start_time.substring(this.start_time.indexOf('T') + 1)}`
      )
      const nowdate = new Date(this.serverdate)
      if (startValue < nowdate) {
        this.showtimeadjust = true
      }
    },
    parse_email (email) {
      // eslint-disable-next-line
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
      return pattern.test(email.toLowerCase())
    },
    screentexts_get: async function () {
      const screentexts = []
      const filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter })
        .then((resp) => {
          const dbtexts = resp.data.result
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    },
    validateform () {
      let formok = true
      this.reminder_email_valid = null
      // Online form
      if (this.reminder === 1) {
        // eslint-disable-next-line
        if (!this.parse_email(this.reminder_email)) {
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.reminder_email) == false) {
          this.reminder_email_valid = 'invalid'
          formok = false
        }
        if (this.reminder_email === '') {
          this.reminder_email_valid = 'invalid'
          formok = false
        }
      }
      return formok
    },
    async groupsurvey_save () {
      // When "Launch Now" is selected, the server time is already in CET, so don't convert it
      // When "Launch Later" is selected, the user enters local time, so convert to CET
      let startCET
      if (this.selected === 'A') {
        // Launch Now - server time is already in CET, use as-is
        startCET = {
          date: this.start_date,
          time: this.start_time || '00:00'
        }
      } else {
        // Launch Later - user entered local time, convert to CET
        startCET = this.local_to_cet(this.start_date, this.start_time)
      }
      
      const survey = {
        id: this.$store.state.currentsurvey_id,
        survey_name: this.$store.state.currentsurvey.survey_name,
        survey_language_id: this.$store.state.currentsurvey.survey_language_id,
        survey_normvalues_id: this.$store.state.currentsurvey.survey_normvalues_id,
        survey_type_id: this.$store.state.currentsurvey.survey_type_id,
        survey_invoice_reference: this.$store.state.currentsurvey.survey_invoice_reference,
        survey_start_date: startCET.date,
        survey_start_time: startCET.time || '00:00',
        survey_end_date: this.format_date(this.end_date),
        survey_reminder_date: this.format_date(this.reminder_date),
        survey_reminder_time: (this.reminder_time !== null) ? this.format_time(this.reminder_time) : '00:00',
        survey_reminder_email: this.reminder_email,
        survey_reminder_mobile: this.reminder_mobile,
        survey_reminder: this.reminder,
        survey_remindparticipants: this.remindparticipants
      }
      await this.$store.dispatch('groupsurvey_save', { survey })
    },
    survey_get: async function () {
      await this.$store.dispatch('groupsurvey_fetch', { id: this.$store.state.currentsurvey_id })
        .then(() => {
          const members = this.$store.state.currentsurveymembers
          const start_date = new Date(this.$store.state.currentsurvey.survey_start_date)
          const today = new Date()
          if (start_date > today) {
            this.selected = 'B'
          }
          for (let i = 0; i < members.length; i++) {
            if (Number(members[i].groupsurveymember_formoption_id) === 1) { this.has_online = 1 }
            if (Number(members[i].groupsurveymember_formoption_id) === 2) { this.has_paper = 1 }
          }
        })
    },
    local_to_cet (localDate, localTime) {
      if (!localDate || !localTime) return { date: localDate || '', time: localTime || '' }
      const timeStr = String(localTime).includes('T')
        ? String(localTime).substring(String(localTime).indexOf('T') + 1, String(localTime).indexOf('T') + 6)
        : String(localTime).substring(0, 5)
      const d = new Date(`${String(localDate).substring(0, 10)}T${timeStr}:00`)
      return {
        date: d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' }),
        time: d.toLocaleTimeString('sv-SE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' })
      }
    },
    format_date (date) {
      if (!date) return ''
      if (date instanceof Date) {
        return date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' })
      }
      return String(date).substring(0, 10)
    },
    format_time (date) {
      const tzdate = new Date(date).toLocaleString('sv-SE', { timeZone: config.timeZone })
      const ret = tzdate.split(' ')[1].substring(0, 5)
      return ret
      // var d = new Date(date)
      // var h = d.getHours()
      // var m = d.getMinutes()
      // var hour = (h > 9 ? '' : '0') + h
      // var minute = (m > 9 ? '' : '0') + m
      // var thistime = hour + ':' + minute
      // return thistime
    },
    default_end_date () {
      let date = new Date()
      date = this.add_months(date, 3)
      return date.toISOString()
    },
    default_start_date () {
      const date = new Date()
      return date.toISOString()
    },
    default_reminder_date () {
      const date = new Date()
      date.setDate(date.getDate() + 87)
      return date.toISOString()
    },
    add_months (date, count) {
      if (date && count) {
        const d = (date = new Date(+date)).getDate()
        date.setMonth(date.getMonth() + count, 1)
        const m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    }
  }
}
</script>
<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
